<app-loader />
@if (toastPosition() === 'top-left') {
<p-toast
  position="top-left"
  role="alert"
  aria-label="Toast Notification"
  aria-live="polite" />
} @else {
<p-toast
  position="top-right"
  role="alert"
  aria-label="Toast Notification"
  aria-live="polite" />
}
<p-confirmDialog
  icon="pi pi-question-circle"
  acceptIcon="pi pi-check"
  rejectIcon="pi pi-times"
  [dismissableMask]="false"
  [acceptLabel]="'common.yes' | translate"
  [rejectLabel]="'common.no' | translate" />
<router-outlet />
